import DashboardPageLayout from "../../components/layout/DashboardPageLayout";

import HomePage from "../../pages/home/HomePage";
import ListagemClientesPage from "../../pages/clientes/ListagemClientesPage";
import NovoClientePage from "../../pages/clientes/NovoClientePage";
import { RouteType } from "../config";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";

const grupoClientes: RouteType = {
  path: "/cliente",
  element: <DashboardPageLayout />,
  state: "cliente",
  show: true,
  sidebarProps: {
    displayText: "Clientes",
    icon: <EmojiPeopleIcon />,
  },

  child: [
    {
      index: true,
      element: <HomePage />,
      state: "cliente.index",
      show: true,
    },
    {
      path: "/cliente/cadastro",
      element: <NovoClientePage />,
      state: "cliente.cadastro",
      show: true,
      sidebarProps: {
        displayText: "Cadastrar cliente",
      },
    },
    {
      path: "/cliente/listagem",
      element: <ListagemClientesPage />,
      state: "cliente.listagem",
      show: true,
      sidebarProps: {
        displayText: "Lista de clientes",
      },
    },

    {
      path: "/cliente/cadastro/:id",
      element: <NovoClientePage />,
      state: "cliente.id",
      show: true,
      verificarPermissao: (usuario) => false,
      sidebarProps: {
        displayText: "Lista de clientes",
      },
    },
  ],
};

export default grupoClientes;
